var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group form-group-sm fg-publisher"},[_c('label',[_vm._v("Remote Publishers")]),_c('v-select',{attrs:{"options":_vm.publisherOptions,"value":_vm.selectedValue,"reduce":o => o.remote_publisher_id,"label":"t"},on:{"input":_vm.onChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }